export default "__VITE_PUBLIC_ASSET__19d58db4__"